var _title, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcFormatAlignJustify = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Align justify")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "align-justify-1",
    x: 0,
    y: 0,
    width: 1280,
    height: 885
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-0.4%",
    y: "-0.5%",
    width: "100.8%",
    height: "101.1%",
    filterUnits: "objectBoundingBox",
    id: "align-justify-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowSpreadOuter2",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.12 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter3",
    result: "shadowBlurOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.14 0",
    type: "matrix",
    in: "shadowBlurOuter3",
    result: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "align-justify-2",
    x: 0,
    y: 0,
    width: 850,
    height: 586,
    rx: 2
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-0.6%",
    y: "-0.7%",
    width: "101.2%",
    height: "101.7%",
    filterUnits: "objectBoundingBox",
    id: "align-justify-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowSpreadOuter2",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.12 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter3",
    result: "shadowBlurOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.14 0",
    type: "matrix",
    in: "shadowBlurOuter3",
    result: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M2.5,17.5 L17.5,17.5 L17.5,15.8333333 L2.5,15.8333333 L2.5,17.5 L2.5,17.5 Z M2.5,14.1666667 L17.5,14.1666667 L17.5,12.5 L2.5,12.5 L2.5,14.1666667 L2.5,14.1666667 Z M2.5,10.8333333 L17.5,10.8333333 L17.5,9.16666667 L2.5,9.16666667 L2.5,10.8333333 L2.5,10.8333333 Z M2.5,7.5 L17.5,7.5 L17.5,5.83333333 L2.5,5.83333333 L2.5,7.5 L2.5,7.5 Z M2.5,2.5 L2.5,4.16666667 L17.5,4.16666667 L17.5,2.5 L2.5,2.5 L2.5,2.5 Z",
    id: "align-justify-21"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "align-justify-15",
    x: 0,
    y: 0,
    width: 41.6666667,
    height: 41.6666667
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "align-justify-5",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "align-justify-6",
    transform: "translate(-929.000000, -403.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 1440,
    height: 1024
  }), /*#__PURE__*/React.createElement("rect", {
    id: "align-justify-8",
    stroke: "#DFE2E5",
    fill: "#F7F8FA",
    x: -0.5,
    y: 123.5,
    width: 1441,
    height: 901
  }), /*#__PURE__*/React.createElement("g", {
    id: "align-justify-7",
    transform: "translate(80.000000, 139.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "align-justify-9"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#align-justify-3)",
    xlinkHref: "#align-justify-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#align-justify-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "align-justify-10",
    transform: "translate(400.000000, 102.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "align-justify-13",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#align-justify-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "align-justify-11"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#align-justify-4)",
    xlinkHref: "#align-justify-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#align-justify-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "align-justify-12",
    mask: "url(#align-justify-13)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 150.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "align-justify-11",
    stroke: "#DFE2E5",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 850,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "align-justify-20",
    stroke: "none",
    fill: "none",
    transform: "translate(447.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "align-justify-19",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#align-justify-21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "align-justify-11"
  }), /*#__PURE__*/React.createElement("g", {
    id: "align-justify-18",
    mask: "url(#align-justify-19)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.833333, -10.833333)",
    id: "align-justify-14"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "align-justify-17",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#align-justify-15"
  })), /*#__PURE__*/React.createElement("use", {
    id: "align-justify-16",
    className: "color-fill",
    fill: "#4F5964",
    xlinkHref: "#align-justify-15"
  }))))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcFormatAlignJustify, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-format-align-justify.7a6aa0ec.svg";
export { ForwardRef as ReactComponent };